import React from 'react';
import { Alert, Table }  from 'reactstrap';
import * as Icon from 'react-feather';
import { ConfirmModal } from '../Modals/Confirm';

export function ConfirmDeleteReportModal(props) {
    return (
        <ConfirmModal
            isOpen={props.isOpen}
            toggle={props.toggle}
            handleConfirm={(e) => props.handleConfirm(props.report, e)}
            title="Delete Report?"
            confirmText="Yes, Delete Report"
            confirmColor="danger"
            confirmIcon={Icon.Trash2}
        >
            <Alert color="warning">
                <strong>Are you sure you wish to delete the following report?</strong>
            </Alert>

            <Table bordered>
                <thead>
                <tr>
                    <th className="col-xs-12">Reference</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{props.report.reference}</td>
                </tr>
                </tbody>
            </Table>
        </ConfirmModal>
    );
}